<script setup lang="ts">
const props = defineProps<{
  open: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'confirm'): void
}>()
</script>

<template>
  <Teleport to="body">
    <div v-if="props.open" class="leave-confirm-backdrop" @click.self="emit('close')">
      <div class="leave-confirm-panel" role="dialog" aria-modal="true" aria-label="Produkteditor verlassen">
        <div class="leave-confirm-head">
          <strong>Produkteditor verlassen?</strong>
          <button class="leave-confirm-close" type="button" aria-label="Schließen" @click="emit('close')">✕</button>
        </div>
        <div class="leave-confirm-body">
          <p>Möchten Sie den Produkteditor wirklich verlassen? Nicht gespeicherte Änderungen können verloren gehen.</p>
        </div>
        <div class="leave-confirm-actions">
          <button class="btn btn--primary" type="button" @click="emit('close')">Bleiben</button>
          <button class="btn" type="button" @click="emit('confirm')">Verlassen</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.leave-confirm-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(6px);
}

.leave-confirm-panel {
  width: min(100%, 460px);
  border-radius: 6px;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}

.leave-confirm-head,
.leave-confirm-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
}

.leave-confirm-head {
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.leave-confirm-body {
  padding: 18px;
  color: #475569;
  line-height: 1.5;
}

.leave-confirm-body p {
  margin: 0;
}

.leave-confirm-actions {
  justify-content: flex-end;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
}

.leave-confirm-close {
  appearance: none;
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 16px;
  cursor: pointer;
}

.btn {
  appearance: none;
  border: 1px solid #d0d7de;
  background: #fff;
  color: #1f2937;
  min-height: 40px;
  padding: 0 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.08s ease;
}

.btn:hover {
  background: #f3f4f6;
  border-color: #d0d7de;
}

.btn:active {
  transform: translateY(1px);
}

.btn--primary {
  border-color: #e30b17;
  background: #e30b17;
  color: #fff;
}

.btn--primary:hover {
  background: #c80913;
  border-color: #c80913;
}
</style>
